import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { AccessManagerService } from 'src/app/auth/accessManager/accessManager.service';
import { VacanciesKpiCfg, VacanciesKpiCfgService } from 'src/app/vacancies/services/vacanciesKpiCfg.service';
import { ColumnDefinition, DateColumnDefinition, LinkColumnData, LinkColumnDefinition, NumberColumnDefinition, TextColumnDefinition } from 'src/app/dashboardCommon/components/cardDetails/datatable.component';
import { VacancieService } from '../../services/vacancie.service';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-vacancies',
    templateUrl: './vacancies.component.html',
    styleUrls: ['./vacancies.component.css'],
    standalone: false
})
export class VacanciesComponent implements OnInit {

  // Loading
  loading: boolean = false;
  columnDefinitions: ColumnDefinition[];
  tabledata: any[] = [];

  constructor(
    private title: Title,
    private vacanciesService: VacancieService,
    private serviceCfg: VacanciesKpiCfgService,
    private accessManagerService: AccessManagerService) {
    this.title.setTitle("Vacantes");

    this.columnDefinitions = this.getDefaultDetailData();
  }

  ngOnInit(): void {
    this.loading = true;

    this.accessManagerService.getResourcePermissions(7437).then(x => {
      const action = x.mResourceActions.find(r => r.ActionTypeId == 1);

      if (action.AllowChk) {
        this.loadData()
      } else {
        window.close();
        throw new Error('No tienes permiso para ingresar a vacantes');
      }
    }).catch((e) => {
      this.loading = false;
      throw e;
    });
  }

  /**
   * Carga los datos de las vacantes
   */
  loadData() {
    this.vacanciesService.getAll()
      .pipe(finalize(() => {
        this.loading = false;
      }))
      .subscribe(data => {

        this.tabledata = [];

        let cfg: VacanciesKpiCfg = this.serviceCfg.getCfg();

        for (let pendingVacancy of data.pendingVacancies) {
          this.tabledata.push([
            new LinkColumnData("", `${cfg.urlTalent}candidates?vacantId=${pendingVacancy.vacantId}&vacantName=${pendingVacancy.proposalDescription}`, cfg.iconUrl),
            pendingVacancy.pCompanyId,
            pendingVacancy.office,
            pendingVacancy.companyName,
            pendingVacancy.center,
            pendingVacancy.serviceOffer,
            pendingVacancy.service,
            pendingVacancy.vacantId,
            pendingVacancy.proposalDescription,
            pendingVacancy.applicationDate,
            pendingVacancy.dateNeeded
          ]);
        }

        this.columnDefinitions = this.getDefaultDetailData();
      });
  }

  /**
   * Obtiene las columnas de la grilla
   * @returns  Listado de columnas
   */
  getDefaultDetailData() {
    let columnDefinitions = [
      new LinkColumnDefinition("", null, false),
      new TextColumnDefinition("Id Compañia", null, true),
      new TextColumnDefinition("Oficina", null, true),
      new TextColumnDefinition("Razon Social", null, true),
      new TextColumnDefinition("Centro", null, true),
      new NumberColumnDefinition("Oferta Servicio", null, true),
      new NumberColumnDefinition("Servicio", null, true),
      new NumberColumnDefinition("Vacante", null, true),
      new TextColumnDefinition("Puesto Solicitado", null, true),
      new DateColumnDefinition("Fecha Solicitud", (data) => this.formatDate(data), true),
      new DateColumnDefinition("Fecha Necesidad", (data) => this.formatDate(data), true),
    ];

    return columnDefinitions;
  }

  /**
   * Transforma la fecha
   */
  formatDate = (value): string => {
    return value != null && value != undefined
      ? moment(value).format("DD/MM/YYYY") : ''
  }
}
